import { CircularProgress, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SwiperSlide } from "swiper/react";
import { Common } from "../../components";
import { ChannelCard } from "../../components/channel";
import { PrimerCard } from "../../components/my-place";
import { ERoute } from "../../constants";
import useConfigureFiles from "../../hooks/useConfigureFiles";

const MyPlace = () => {
  const { t } = useTranslation("page");

  const [pageState, setPageState] = useState({
    location: "",
    isLoading: false,
  });

  const { refetch, myPlace, isLoading } = useConfigureFiles(pageState.location);
  const myPlaceChannels = myPlace?.subChannels || [];


  const handleEnableLocation = () => {
    setPageState((prev) => ({ ...prev, isLoading: true }));
    navigator.geolocation.getCurrentPosition(
      (response) => {
        if (response) {
          setPageState((prev) => ({
            ...prev,
            location: `${response.coords.latitude},${response.coords.longitude}`,
            isLoading: false,
          }));
        }
      },
      () => {
        setPageState((prev) => ({ ...prev, isLoading: false }));
      }
    );
  };

  useEffect(() => {
    setPageState((prev) => ({ ...prev, isLoading: true }));
    handleEnableLocation();
  }, []);

  useEffect(() => {
    if (pageState.location) {
      refetch();
    }
    //eslint-disable-next-line
  }, [pageState.isLoading]);

  if (pageState.isLoading || isLoading) {
    return <CircularProgress />;
  }

  if (!navigator.geolocation || !pageState.location) {
    return (
      <Grid item>
        <Common.SubHeading>
          {t("myPlace.videoFromLocalCommunity")}
        </Common.SubHeading>
        <PrimerCard
          disabled={!Boolean(pageState.location)}
          onEnableLocation={handleEnableLocation}
        />
      </Grid>
    );
  }

  if (!myPlaceChannels || !myPlaceChannels?.length || !pageState.location) {
    return <Typography>No channel available</Typography>;
  }

  return (
    <Grid container direction="column">
      <Common.Carousel total={myPlaceChannels.length || 0}>
        {myPlaceChannels.map((c, idx) => (
          <SwiperSlide
            key={idx}
            style={{ display: "flex", alignItems: "center" }}
          >
            <ChannelCard
              {...c}
              channelPath={c.title}
              id={c.id.toString()}
              cardImg={c.thumbnail}
              path={`/${ERoute.CHANNEL}/${c.parentId}+${c.id}`}
            />
          </SwiperSlide>
        ))}
      </Common.Carousel>
    </Grid>
  );
};

export default MyPlace;
